export default __webpack_public_path__ + "static/media/icon-gb.10129a7b.svg";